var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.isIMEI ? _vm.$t("editIMEI") : _vm.$t("editSN"),
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("confirm"),
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              [
                _c("v-combobox", {
                  attrs: {
                    value: _vm.snArrayInEdit,
                    chips: "",
                    multiple: "",
                    "deletable-chips": "",
                    "prepend-icon": "filter_list",
                    suffix: _vm.snArrayInEdit.length.toString(),
                    clearable: ""
                  },
                  on: { change: _vm.onSnChanged }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74878058", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74878058","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SnArrayEditPopup.vue
// module id = null
// module chunks = 